

function getTenantLogoUrl(positive = true): string {
    
    return "/api/1.0/logo/" + (positive ? "positive" : "negative");
}

export { getTenantLogoUrl };